/** Label for restaurant-scoped breadcrumbs (never the platform "Home"). */
export function getRestaurantBreadcrumbLabel(
  restaurantName?: string | null,
  appName?: string
): string {
  const trimmed = restaurantName?.trim();
  if (trimmed) return trimmed;
  if (appName) {
    return appName
      .split('-')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
  return 'Restaurant';
}

export function restaurantHomePath(appName?: string): string {
  return appName ? `/restaurants/${appName}` : '/';
}
